export default __webpack_public_path__ + "static/media/whale2.9b053f35.png";